import Http from "@/commons/Http";

const path = '/api/protocolo';

const normalizarPagamentoVinculado = (pendencia) => ({
  ...pendencia,
  custas: typeof pendencia.custas === 'string' ? JSON.parse(pendencia.custas) : (pendencia.custas || {})
});

export default {

  async listarPagamentoPosteriorAverbacaoCancelamento(protocoloId, atoId) {
    return Http.get(`${path}/${protocoloId}/ato/${atoId}/pagamento-posterior`);
  },

  async salvarSelecaoPagamentoPosteriorAverbacaoCancelamento(protocoloId, atoId, selecionados) {
    return Http.post(`${path}/${protocoloId}/ato/${atoId}/pagamento-posterior`, selecionados);
  },

  async listarPagamentoPosteriorProtocolo(protocoloId) {
    return Http.get(`${path}/${protocoloId}/pagamento-posterior`);
  },

  async desvincularPagamentoPosteriorProtocolo(protocoloId, pendenciaId) {
    return Http.post(`${path}/${protocoloId}/pagamento-posterior/${pendenciaId}/desvincular`);
  },

  async buscarCustasPagamentoPosterior(protocoloId, pendenciaId) {
    return Http.get(`${path}/${protocoloId}/pagamento-posterior/${pendenciaId}/custas`);
  },

  async listarPagamentosVinculadosAtoAverbacaoCancelamento(protocoloId, atoId) {
    return Http.get(`${path}/${protocoloId}/pagamento-posterior/ato/${atoId}`);
  },

  async listarPagamentosVinculadosAtoAverbacaoCancelamentoNormalizados(protocoloId, atoId) {
    const lista = await this.listarPagamentosVinculadosAtoAverbacaoCancelamento(protocoloId, atoId) || [];
    return lista.map(normalizarPagamentoVinculado);
  },

  async listarAtosElegiveisParaVinculo(protocoloId, atoId) {
    return Http.get(`${path}/${protocoloId}/pagamento-posterior/ato/${atoId}/atos-elegiveis`);
  },

  async simularValoresPagamentoPosterior(protocoloId, atoId, referenciaAtoId) {
    return Http.get(`${path}/${protocoloId}/pagamento-posterior/ato/${atoId}/simular/${referenciaAtoId}`);
  },

  async simularPrenotacaoPagamentoPosterior(protocoloId, atoId, referenciaAtoId, prenotacaoCustaAdicionalId) {
    return Http.get(`${path}/${protocoloId}/pagamento-posterior/ato/${atoId}/simular-prenotacao/${referenciaAtoId}/${prenotacaoCustaAdicionalId}`);
  },

  async buscarPrenotacaoProtocolo(protocoloId, protocoloReferenciaId) {
    return Http.get(`${path}/${protocoloId}/pagamento-posterior/prenotacao-por-protocolo/${protocoloReferenciaId}`);
  },

  async criarPagamentosVinculados(protocoloId, atoId, dto) {
    return Http.post(`${path}/${protocoloId}/pagamento-posterior/ato/${atoId}/criar-vinculados`, dto);
  },

  isNumeroProcessoJudicialObrigatorio($root, item) {
    return $root.isEstadoRJ && item?.tipoRegistro === 'COBRANCA_POSTERGADA_DECISAO_JUDICIAL';
  },

  validarNumeroProcessoJudicial($root, item) {
    if (!this.isNumeroProcessoJudicialObrigatorio($root, item)) {
      return null;
    }
    const valor = item?.dto?.camposAdicionais?.NUMERO_PROCESSO_JUDICIAL;
    return !valor || !String(valor).trim() ? 'Campo obrigatório' : null;
  },

}
